import { OfferSellerContainer } from '../../containers/advancedFilters/OfferSellerContainer';
import { IFilter } from '../../types/advancedFilters';

export const offerSeller: IFilter = {
  component: OfferSellerContainer,
};
